import React, {useContext, useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import {ScrollTrigger} from "gsap/dist/ScrollTrigger";
import SmootherContext from "../../components/SmootherContext";
import {NextSeo} from "next-seo";
import {useRouter} from "next/router";
import {Col, Container, Row} from "react-bootstrap";
import {EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton} from "react-share";
import Button from "../../components/Button";
import ReactHtmlParser from "react-html-parser";
import reactHtmlParser from "react-html-parser";
import {Img} from "../../components/Img";
import styled from "styled-components";
import {hover, title} from "../../styles/globalStyleVars";
import ErrorPage from "../../components/error/404";

const PostDetail = ({data}) => {

    let detailData = useSelector(state => state.newsReducer)
    const router = useRouter();

    let getData = data && data?.data?.data
    let getImages = data && data?.data?.images
    let banner = getImages?.list.find(f => f?.banner === 'on')

    let [shareUrl, setShareUrl] = useState('')

    let shareButtonClickM = useRef()
    let shareButtonContentM = useRef()

    useEffect(() => {
        setShareUrl(window.location.href)
    }, [shareUrl])

    useEffect(() => {
        shareButtonClickM?.current?.addEventListener('click', () => {
            shareButtonContentM.current?.classList.toggle('open')
        })

        window.addEventListener('click', (e) => {
            if (shareButtonContentM?.current?.classList.contains('open')) {
                if (!e.target.matches('.social-vertical, .social-vertical img')) {
                    shareButtonContentM?.current?.classList.remove('open')
                }
            }

        })


    }, [shareButtonContentM])


    useEffect(() => {
        const contentRefs = document.querySelectorAll('.pin-it');

        if (contentRefs) {
            contentRefs.forEach((box) => {
                ScrollTrigger.create({
                    trigger: box,
                    pin: true,
                    start: 'top +200',
                    end: 'bottom',
                    pinSpacing: false
                });
            });
        }
    }, []);

    const smoother = useContext(SmootherContext);
    const killSmoother = () => {
        if (smoother && smoother.revert) {
            smoother.revert();
        }
    };

    const currentUrlTag = router && router.asPath;



    var dateString = getData?.date;
    var date = new Date(dateString);

// Array of month names
    var months = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
    ];

// Extracting day, month, and year from the date object
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

// Constructing the formatted date string
    var formattedDate = day + " " + months[monthIndex] + " " + year;


    return (
        <div>


            {
                getData ?
            <NextSeo
                title={`${getData?.title ? getData?.title + ' | News | ' : ''}Shanta Securities Limited`}
                description={getData?.meta_description}
                canonical={"https://www.shantasecurities.com"+currentUrlTag}
                openGraph={{
                    title: getData?.title,
                    description: getData?.meta_description,
                    images: [
                        {
                            url: banner?.full_path,
                            width: 800,
                            height: 600,
                            alt: getData?.title,
                        },
                        {
                            url:  banner?.full_path,
                            width: 800,
                            height: 600,
                            alt: getData?.title,
                        },
                    ],
                }}
            /> :
                    <NextSeo
                        title={`404 - Shanta Securities Limited`}
                    />
            }

            <StyledComponent>


                {
                    getData ?
                        <section id={'details'} className="case_study_detail pb-160">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <div>
                                            <div className="social-vertical pin-it" ref={shareButtonClickM}>
                                                <p>Share:</p>
                                                <div className="clearfix"></div>
                                                <div className="social-lists" ref={shareButtonContentM}>
                                                    <FacebookShareButton url={shareUrl}><FacebookIcon size={32}
                                                                                                      round={true}/></FacebookShareButton>
                                                    <LinkedinShareButton url={shareUrl}><LinkedinIcon size={32}
                                                                                                      round={true}/></LinkedinShareButton>
                                                    <EmailShareButton url={shareUrl}><EmailIcon size={32}
                                                                                                round={true}></EmailIcon></EmailShareButton>
                                                </div>

                                            </div>


                                            <div className="video">
                                                {
                                                    getData?.data?.link &&
                                                    <div className="click" onClick={() => handleShow(true)}>

                                                        <Button iconvideo newtablink={'javascript:void(0)'}
                                                                text={"Watch Video"}
                                                                margin={"30px 0 0 0"}
                                                                background={"white"}
                                                                color={"#3C3C3B"} borderColor={'#3C3C3B'}
                                                                icon border={'1px solid'}
                                                        />


                                                    </div>
                                                }
                                            </div>

                                        </div>
                                    </Col>
                                    <Col md={{span: 9}}>
                                        <div className="header">
                                            {
                                                getData?.title ?
                                                    <h1 className={'split-up'}>{ReactHtmlParser(getData?.title)}</h1>

                                                    :
                                                    <h1>Offer on Domestic Flights</h1>
                                            }

                                            <p>
                                                {
                                                    getData?.chapter ?
                                                        <span>{getData?.chapter} Chapters</span> :
                                                        <span className={``}>Date: {formattedDate}</span>
                                                }


                                            </p>
                                        </div>
                                        <div className="case_study_image_wrapper">
                                            {

                                                banner?.full_path ?
                                                    <Img src={banner?.full_path}/>
                                                    :
                                                    null
                                            }
                                        </div>
                                        <div className="blog_details">
                                            {
                                                getData?.body &&
                                                reactHtmlParser(getData?.body)
                                            }

                                        </div>

                                    </Col>

                                </Row>
                            </Container>

                        </section>
                        :
                        <ErrorPage/>

                }

            </StyledComponent>
        </div>
    );
};

const StyledComponent = styled.section`


    position: relative;

    .position_relative {
        position: relative;
    }

    iframe {
        margin-top: 10px;
        width: 100%;
        min-height: 400px;
        @media (max-width: 767px) {
            height: 190px;
            min-height: auto;
        }
    }

    a {
        color: ${hover}
    }

    .case_study_detail {
        padding-top: 150px;

        .header {
            margin-bottom: 40px;

            p {
                font-size: 12px;
                font-weight: 500;
                line-height: 16px;
                color: #3C3C3B;

                span {
                    border-right: 1px solid rgba(60, 60, 59, 0.2);
                    padding-right: 20px;
                    padding-left: 20px;

                    &.red {
                        color: #d20f0f;
                    }

                    &:last-child {
                        padding-right: 20px;
                        border-right: 0;
                    }

                    &:first-child {
                        padding-left: 0;
                    }
                }


            }

            h1 {
                font-size: 32px;
                font-weight: 500;
                line-height: 32px;
                color: #978C21;
                margin: 0 0 10px;
                font-family: ${title};
            }
        }

        .case_study_image_wrapper {
            position: relative;
            padding-top: 50%;


        }

        .blog_details {
            padding-top: 80px;


            .ratio {
                position: relative;
                padding-top: 50%;

                iframe {
                    position: absolute;
                    inset: 0px;
                    object-fit: cover;
                    min-height: unset;
                    height: 100%;
                    width: 100%;
                }
            }

            h6 {
                font-size: 20px;
                font-weight: 500;
                line-height: 24px;
                margin-bottom: 5px;
            }

            h3 {
                font-size: 24px;
                font-weight: 500;
                line-height: 28px;
                color: #978C21;
                margin-bottom: 20px;
            }

            p {
                margin-bottom: 40px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .flex {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: flex-start;

                img {
                    flex: 0 0 calc(50% - 15px);
                    display: block;
                    max-width: calc(50% - 15px);
                    @media (max-width: 767px) {
                        flex: 0 0 calc(50% - 7.5px);
                        display: block;
                        max-width: calc(50% - 7.5px);
                    }
                }
            }

            ul {
                margin-bottom: 20px;

                li {
                    padding-left: 15px;
                    margin-bottom: 10px;
                    position: relative;

                    &:after {
                        position: absolute;
                        left: 0;
                        top: 9px;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        content: '';
                        background: ${hover};
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

    .social-vertical {


        p {
            margin-bottom: 20px;
        }


    }

    .social-lists {
        display: flex;
        //flex-direction: column;
        width: auto;
        align-items: flex-start;
        @media (max-width: 767px) {
            flex-direction: row;

        }

        svg {
            height: 30px;
            width: 30px;

            circle {
                fill: transparent;
                stroke: #978C21;
            }

            path {
                fill: #978C21;
            }


            &:hover {
                circle {
                    stroke: #3C3C3B;

                }

                path {
                    fill: #3C3C3B;
                }
            }
        }

        button {
            margin-right: 20px;
            @media (max-width: 767px) {
                margin-bottom: 0px;
                margin-left: 0px;
                margin-right: 10px;
            }

            &:last-child {
                margin-bottom: 20px;
            }
        }
    }

    @media (max-width: 992px) {
        .case_study_detail {
            .row {
                flex-direction: column-reverse;

                .col-md-9, .col-md-3 {
                    width: 100%;
                    max-width: 100%;

                }
            }

            .social-vertical {
                margin-top: 60px;
            }
        }
    }

    @media (max-width: 767px) {
        table{
            display: block;
            overflow-x: scroll;
            overflow-y: scroll;
        }
        .case_study_detail {
            padding-top: 150px;
        }

        .case_study_detail .case_study_image_wrapper {
            //padding-top: 22vh;
        }
    }

`;




export async function getServerSideProps(context) {
    const { query } = context;
    const { slug } = query;

    // Fetch data from an API or perform any async operations based on the slug
    const res = await fetch(`http://cms.shantasecurities.com/api/get-req-data/blog-data?type=slug&value=${slug}`);
    const data = await res.json();

    // Pass fetched data as props to the component
    return {
        props: {
            data,
        },
    };
}



export default PostDetail;
